import { ReactNode } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { cn } from '@/lib/utils'

const navLinkClass = ({ active }: { active?: boolean } = {}) =>
  cn(
    'rounded-md px-3 py-2 text-sm font-medium transition-colors',
    'hover:bg-secondary',
  )

export default function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth()

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 border-b bg-background/90 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2">
            <img src="/voicetoaster.png" alt="" className="h-8 w-8 rounded-md" />
            <span className="font-display text-lg font-semibold tracking-tight">Voice Toaster</span>
          </Link>
          <nav className="flex items-center gap-1">
            <NavLink exact to="/" className={navLinkClass()} activeClassName="bg-secondary">
              Warm up
            </NavLink>
            <NavLink to="/warmups" className={navLinkClass()} activeClassName="bg-secondary">
              Exercises
            </NavLink>
            {user ? (
              <>
                <NavLink to="/studio" className={navLinkClass()} activeClassName="bg-secondary">
                  Studio
                </NavLink>
                <button onClick={logout} className={navLinkClass()}>
                  Log out
                </button>
              </>
            ) : (
              <NavLink to="/login" className={navLinkClass()} activeClassName="bg-secondary">
                Log in
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t py-6">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-2 px-4">
          <p className="spec-label">
            Voice Toaster · Model VT-1 · Vocal warming apparatus
          </p>
          <Link to="/approach" className="spec-label hover:text-foreground">
            The approach
          </Link>
        </div>
      </footer>
    </div>
  )
}
